import { useEffect, useState } from 'react';

import { Card, CardBody, Col, Row, Container, Label } from 'reactstrap';

const Details = ({ details }) => {
  const [completeDetails, setCompleteDetails] = useState([]);

  useEffect(() => {
    setCompleteDetails(details);
  }, [details]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: `smooth` });
  }, []);

  return (
    <Container fluid>
      {/* <button onClick={() => console.log({ details })}>Get state</button> */}
      <Row>
        <Col lg={12}>
          <Card className="mt-n4 mx-n4 mb-n5">
            <div className="bg-soft-warning">
              <CardBody className="pb-4 mb-5">
                <Row>
                  <div className="col-md">
                    <Row className="align-items-center">
                      <div className="col-md-auto mb-1 mt-4"></div>
                      <div className="col-md">
                        <h4 className="fw-semibold" id="ticket-title">
                          {details?.objectId || ''}
                        </h4>
                      </div>
                    </Row>
                  </div>
                </Row>
              </CardBody>
            </div>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xxl={12}>
          <Card>
            <CardBody className="p-4">
              <h6 className="fw-semibold text-uppercase mb-3">Details</h6>
              <div className="border mt-2 mb-3 border"></div>
              <Row>
                <Col md={4}>
                  <div className="mb-3">
                    <Label className="d-flex">{'Name'}</Label>
                    <Label className="text-muted">{details?.name || `NA`}</Label>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xxl={12}>
          <Card>
            <CardBody className="p-4">
              <h6 className="fw-semibold text-uppercase mb-3">Descriptions</h6>
              <div className="border mt-2 mb-3 border"></div>
              <Row>
                <Col md={12}>
                  <div className="mb-3">
                    <Label className="d-flex">{'Short Description'}</Label>
                    <Label className="text-muted">{details?.shortDescription || `NA`}</Label>
                  </div>
                </Col>

                <Col md={12}>
                  <div className="mb-3">
                    <Label className="d-flex">{'Long Description'}</Label>
                    <Label className="text-muted">{details?.longDescription || `NA`}</Label>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Details;
